import { render } from "./RegistryEntry.vue?vue&type=template&id=118313bc&scoped=true"
import script from "./RegistryEntry.vue?vue&type=script&lang=js"
export * from "./RegistryEntry.vue?vue&type=script&lang=js"

import "./RegistryEntry.vue?vue&type=style&index=0&id=118313bc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118313bc"]])

export default __exports__